import type { SVGProps } from 'react';

import theme from '@styles/theme';

export const DocumentBlank = ({
  width = 20,
  height = 20,
  stroke = theme.palette.text[11],
  strokeWidth = 1.3,
  className = '',
  ...otherProps
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    {...otherProps}
  >
    <path
      d='M16.6668 7.08333H13.7502C12.8297 7.08333 12.0835 6.33714 12.0835 5.41667V2.5M5.8335 17.5H14.1668C15.5475 17.5 16.6668 16.3807 16.6668 15V6.97639C16.6668 6.31335 16.4034 5.67747 15.9346 5.20862L13.9582 3.23223C13.4894 2.76339 12.8535 2.5 12.1904 2.5H5.8335C4.45278 2.5 3.3335 3.61929 3.3335 5V15C3.3335 16.3807 4.45278 17.5 5.8335 17.5Z'
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
